module.exports = __webpack_public_path__ + "public/SiteIcons/moreItinerary.svg?6aca8c17";